// 交易看板表格组件
export default {
  // 表格头部
  totalRecords: "共计",
  records: "条数据",
  loading: "拼命加载中",

  // 表格列标题
  blockchain: "公链",
  address: "地址",
  transferInCount: "转入次数",
  transferInAmount: "转入数量",
  transferOutCount: "转出次数",
  transferOutAmount: "转出数量",
  remark: "备注",
  action: "操作",

  // 备注相关
  addRemark: "点击添加备注",
  remarkSuccess: "备注成功",

  // 操作按钮
  delete: "删除",
  download: "下载数据明细",

  // 空状态
  noData: "暂无数据",

  // 消息提示
  addressNotFound: "没有查出该地址",
  copySuccess: "复制成功",
  deleteConfirm: "是否删除此条地址?",
  deleteSuccess: "删除成功",
  deleteCancelled: "已取消删除",
  lastAddressWarning: "此地址为最后一条，不可删除",

  // 对话框
  tip: "删除确认",
  confirm: "确定",
  cancel: "取消",
  warning: "警告",
};
